export default __webpack_public_path__ + "images/bank-logos-v2/handelsbanken.png";